import React, { forwardRef } from 'react';

import PropTypes from 'prop-types';

import styles from './Item.module.css';

export const Position = { After: 1, Before: -1 };

const DraggableItemWrapper = forwardRef((props, ref) => {
    const { active, clone, insertPosition, id, style, dragProps, children } =
        props;

    const classnames = [styles.Wrapper];
    if (active) classnames.push(styles.active);
    if (clone) classnames.push(styles.clone);
    if (insertPosition === Position.Before)
        classnames.push(styles.insertBefore);
    if (insertPosition === Position.After) classnames.push(styles.insertAfter);

    return (
        <li className={classnames.join(' ')} ref={ref} style={style}>
            <div data-id={id.toString()} {...dragProps}>
                {children}
            </div>
        </li>
    );
});

DraggableItemWrapper.displayName = 'DraggableItemWrapper';

DraggableItemWrapper.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node,
    clone: PropTypes.bool,
    dragProps: PropTypes.object,
    id: PropTypes.string,
    insertPosition: PropTypes.oneOf([Position.After, Position.Before]),
    style: PropTypes.object,
};

export default DraggableItemWrapper;
